module.exports = __webpack_public_path__ + "img/qrcodeNewUI.d647bf94.png";